var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about container"},[_c('h1',[_vm._v("\n    "+_vm._s(_vm.$t('Footer.Disclaimer'))+"\n  ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('Disclaimer'))}}),_c('br'),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }